import { Button, Result } from 'antd';
import type { ResultProps } from 'antd';
import { ApiError } from '@/lib/http/http-api';
import { t } from '@/lib/i18n';

type StatusPageProps = {
  status?: number;
  error?: unknown;
  onRetry?: () => unknown;
};

export function StatusPage({ status, error, onRetry }: StatusPageProps) {
  const code = status ?? (error instanceof ApiError ? error.status : 500);
  let illustration: ResultProps['status'] = 'error';
  let title = t('页面出错了');
  let description = t('页面暂时无法加载，请稍后重试。');

  switch (code) {
    case 0:
      title = t('连接失败');
      description = t('无法连接服务器，请检查网络后重试。');
      break;
    case 401:
      title = '401';
      description = t('登录已失效，请重新登录。');
      break;
    case 403:
      illustration = '403';
      title = '403';
      description = t('当前账号没有访问权限。');
      break;
    case 404:
      illustration = '404';
      title = '404';
      description = t('页面或资源不存在，可能已被移除。');
      break;
    case 429:
      illustration = 'warning';
      title = '429';
      description = t('请求过于频繁，请稍后重试。');
      break;
    default:
      if (code >= 500 && code <= 599) {
        illustration = '500';
        title = String(code);
        description = t('服务暂时不可用，请稍后重试。');
      }
  }

  return (
    <Result
      className="mx-auto w-full max-w-3xl py-12"
      status={illustration}
      title={title}
      subTitle={description}
      extra={
        <div className="flex flex-wrap justify-center gap-3">
          {onRetry && code !== 401 && code !== 403 && code !== 404 ? (
            <Button type="primary" onClick={() => void onRetry()}>
              {t('重试')}
            </Button>
          ) : null}
          {code === 401 ? (
            <Button type="primary" href="/login">
              {t('重新登录')}
            </Button>
          ) : null}
          <Button href="/">{t('返回运营工作台')}</Button>
        </div>
      }
    />
  );
}
